module.exports = __webpack_public_path__ + "static/media/20.222c885c.svg";